import { inject } from '@angular/core';
import { RedirectCommand, type ResolveFn, Router } from '@angular/router';
import { catchError, of, tap } from 'rxjs';

import { DEFAULT_LANGUAGE } from '~constants/translations';
import type { Station } from '~models/station.model';
import { StationsService } from '~services/station.service';

export const singleStationResolver: ResolveFn<Station> = (route) => {
  const stationsService = inject(StationsService);
  const router = inject(Router);
  const lang = route.paramMap.get('lang') ?? DEFAULT_LANGUAGE;
  const stationId = route.paramMap.get('stationId');
  const redirectPath = router.parseUrl(`${lang}${window.location.search}`);

  if (!stationId) {
    console.warn('[SingleStationResolver] stationId parameter is empty');

    return of(new RedirectCommand(redirectPath));
  }

  return stationsService.getStation(stationId).pipe(
    tap((station: Station) => {
      stationsService.selectStation(station);
    }),
    catchError(() => {
      console.warn(
        `[SingleStationResolver] Could not get station with stationId: ${stationId}. Navigating to normal mode.`,
      );

      return of(new RedirectCommand(redirectPath));
    }),
  );
};
